import { merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';
import Chart from './Chart.jsx'
import '../app.scss';
import Benzinger from './Benzinger';

const expectedCol = { backgroundColor: 'white', fontSize: '80%', border: '0px' };
const resultCell = { backgroundColor: '#595959', color: 'white' };
const header = { border: '0px', fontSize: '65%', backgroundColor: 'white' };

export default class BenzingerChartDataForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      imagen: ['0', '0', '0', '0'],
      adjetivo: '',
      totalExIn: [0, 0],
      adultoExIn: [0, 0],
      jovenExIn: [0, 0],
      posDetNegEst: [0, 0, 0, 0],
      adultoStats: {
        AT: [0, 0, 0, 0],
        ATL: [0, 0, 0, 0],
        AA: [0, 0, 0, 0],
      },
      jovenStats: [0, 0, 0, 0],
    };
  }
  render() {
    return (
      <div>
        <table className='yellow-input-table' style={{ tableLayout: 'fixed', marginBottom: '10px' }}>
          <tbody>
            <tr>
              <td style={{ visibility: 'hidden', border: '0px' }}>.</td>
              {R.map((prop) => <td style={header} key={`posDetNegEst${prop}`}>{prop}</td>, ['POS', 'DET', 'NEG', 'EST'])}
            </tr>
            {this.renderPosDetNegEst()}

            <tr style={{ visibility: 'hidden', border: 'white' }}>{R.map((i) => <td key={`empty1${i}`} style={{ border: '0px' }}></td>, [0, 1, 2, 3, 4, 5])}</tr>

            <tr>
              {['', 'FI 7', 'PI 1', 'PD 2', 'FD 8', 'SUM'].map((prop) => <td style={header} key={prop}>{prop}</td>)}
            </tr>
            {this.renderAdultoStatsRow('AT', 'Adulto Trabajo', 144)}
            {this.renderAdultoStatsRow('ATL', 'Adulto T. Libre', 81)}
            {this.renderAdultoStatsRow('AA', 'Adulto Autodesc.', 90)}
            {this.renderAdultoTotal()}

            <tr style={{ visibility: 'hidden', border: 'white' }}>{R.map((i) => <td key={`empty2${i}`} style={{ border: '0px' }}></td>, [0, 1, 2, 3, 4, 5])}</tr>

            <tr style={{ visibility: 'hidden' }}><td>.</td><td>.</td><td>.</td><td>.</td><td>.</td></tr>

            {this.renderJovenImagen()}
            {this.renderJovenAdjetivo()}
            {this.renderJovenRow()}
            {this.renderJovenTotal()}

            <tr style={{ visibility: 'hidden', border: 'white' }}>{R.map((i) => <td key={`empty2${i}`} style={{ border: '0px' }}></td>, [0, 1, 2, 3, 4, 5])}</tr>

            <tr>
              <td style={{ visibility: 'hidden', border: '0px' }}>.</td>
              {R.map((prop) => <td style={header} key={`rowJoven${prop}`}>{prop}</td>, ['EX', 'IN'])}
            </tr>

            {this.renderExIn('adulto', 'Adulto')}
            {this.renderExIn('joven', 'Joven')}
            {this.renderExIn('total', 'Total')}
          </tbody>
        </table>
      </div>
    );
  }
  notifyChange(newState) {
    const st = R.merge(this.state, newState);
    this.props.onChange({
      A1: st.adultoStats.AT[0] + st.adultoStats.AA[0] + st.adultoStats.ATL[0],
      L1: st.adultoStats.AT[1] + st.adultoStats.AA[1] + st.adultoStats.ATL[1],
      I1: st.adultoStats.AT[2] + st.adultoStats.AA[2] + st.adultoStats.ATL[2],
      V1: st.adultoStats.AT[3] + st.adultoStats.AA[3] + st.adultoStats.ATL[3],
      A2: st.jovenStats[0],
      L2: st.jovenStats[1],
      I2: st.jovenStats[2],
      V2: st.jovenStats[3],
      adultoStats: st.adultoStats,
      imagen: st.imagen,
      jovenExIn: st.jovenExIn,
      adultoExIn: st.adultoExIn,
      totalExIn: st.totalExIn,
      adjetivo: st.adjetivo,
      posDetNegEst: st.posDetNegEst,
      valid: true,
    });
  }
  setStateAndNotify(state) {
    this.setState(state);
    this.notifyChange(state);
  }
  renderExIn(field, label) {
    const onChange = (index) => (value) => this.setStateAndNotify({ [`${field}ExIn`]: R.update(index, value, this.state[`${field}ExIn`])});
    return (<tr>
      <td>{label}</td>
      <td><NumberInput className='form-control' onChange={onChange(0)} value={this.state[`${field}ExIn`][0]} min='0' max='30'></NumberInput></td>
      <td><NumberInput className='form-control' onChange={onChange(1)} value={this.state[`${field}ExIn`][1]} min='0' max='30'></NumberInput></td>
    </tr>);
  }
  renderPosDetNegEst() {
    const renderCell = (prop, index) => (
      <td key={`rowPosDetNegEst${index}`}><NumberInput className='form-control' onChange={this.handlePosDetNegEstChange(index)} value={this.state.posDetNegEst[index]} min='0' max='50'></NumberInput></td>
    );
    return (<tr>
      <td style={{ visibility: 'hidden' }}>.</td>
      {R.addIndex(R.map)(renderCell, ['POS', 'DET', 'NEG', 'EST'])}
    </tr>);
  }
  handlePosDetNegEstChange(index) {
    return (value) => {
      const statValues = this.state.posDetNegEst;
      const newValues = R.update(index, value, statValues);
      this.setStateAndNotify({ posDetNegEst: newValues });
    }
  }
  renderJovenTotal() {
    return (<tr>
      <td>Joven x 4</td>
      {R.map((index) => (<td style={resultCell} key={`rowJovenTotal${index}`}>{this.state.jovenStats[index] * 4}</td>), [0, 1, 2, 3])}
      <td style={resultCell}></td>
    </tr>);
  }
  renderJovenRow() {
    const renderJovenCell = (prop, index) => (
      <td key={`rowJoven${prop}`}><NumberInput className='form-control' onChange={this.handleJovenStatChange(index)} value={this.state.jovenStats[index]} min='0' max='100'></NumberInput></td>
    );
    return (<tr>
      <td key={`rowJoven`}>Joven</td>
      {R.addIndex(R.map)(renderJovenCell, ['FI', 'PI', 'PD', 'FD'])}
      <td style={resultCell} key={`rowJovenSum`}>{R.sum(this.state.jovenStats)}</td>
      <td style={expectedCol}>81</td>
    </tr>);
  }
  renderJovenAdjetivo() {
    return (<tr>
      <td>Adjetivo</td>
      <td colSpan='4'><input type='text' value={this.state.adjetivo} onChange={(event) => this.setStateAndNotify({ adjetivo: event.target.value })}></input></td>
      <td style={resultCell}></td>
    </tr>);
  }
  renderJovenImagen() {
    const onImagenChange = (index) => (event) => {
      const newVal = event.target.value.toUpperCase();
      const prevVal = this.state.imagen[index];
      let val = null;
      if (newVal === '') val = '0';
      else if (newVal.length === 1) val = newVal;
      else if (newVal.length > 2) return;
      else if (newVal[0] === prevVal) val = newVal[1];
      else if (newVal[1] === prevVal) val = newVal[0];
      if (val !== '0' && val !== 'M' && val !== 'N') return;

      const newImagen = R.update(index, val, this.state.imagen);
      if (val !== '0')
        for (let i = 0; i < 4; i++)
          if (i != index && newImagen[i] === val)
            newImagen[i] = '0';

      this.setStateAndNotify({ imagen: newImagen });
    };

    const cellStyle = (value) => {
      return { backgroundColor: value === 'M' ? 'green' : value === 'N' ? 'orange' : '#fffd38', color: value === 'M' ? 'white' : 'black' };
    };

    return (<tr>
      <td>Imagen</td>
      {R.addIndex(R.map)((prop, index) => <td style={cellStyle(this.state.imagen[index])} key={`rowJovenImage${prop}`}><input style={cellStyle(this.state.imagen[index])} type='text' value={this.state.imagen[index]} onChange={onImagenChange(index)}></input></td>, ['FI', 'PI', 'PD', 'FD'])}
      <td style={resultCell}></td>
    </tr>);
  }
  renderAdultoStatsRow(stat, label, expectedSum) {
    const resultValue = R.sum(this.state.adultoStats[stat]);
    const matchesExpected = resultValue === expectedSum;
    const resultColor = resultValue === 0 ? '#595959' : matchesExpected ? 'green' : 'red';
    const renderAdultoCell = (prop, index) => (
      <td key={`row${stat}${prop}`}><NumberInput className='form-control' onChange={this.handleAdultoStatChange(stat, index)} value={this.state.adultoStats[stat][index]} min='0' max='144'></NumberInput></td>
    );
    return (<tr>
      <td key={`row${stat}`}>{label}</td>
      {R.addIndex(R.map)(renderAdultoCell, ['FI', 'PI', 'PD', 'FD'])}
      <td style={{ backgroundColor: resultColor, color: 'white' }} key={`row${stat}sum`}>{resultValue}</td>
      <td style={expectedCol}>{expectedSum}</td>
    </tr>);
  }
  renderAdultoTotal() {
    const expectedValue = 315;
    const resultValue = R.sum(this.state.adultoStats['AT']) + R.sum(this.state.adultoStats['ATL']) + R.sum(this.state.adultoStats['AA']);
    const matchesExpected = resultValue === expectedValue;
    const resultColor = resultValue === 0 ? '#fffd38' : matchesExpected ? 'green' : 'red';
    return (<tr>
      <td key='rowAdultoTotal'>Adulto Total</td>
      {R.map((index) => (<td style={resultCell} key={`rowAdultoTotal${index}`}>{this.state.adultoStats['AT'][index] + this.state.adultoStats['ATL'][index] + this.state.adultoStats['AA'][index]}</td>), [0, 1, 2, 3])}
      <td style={{ backgroundColor: resultColor, color: resultValue !== 0 ? 'white' : 'black' }} key='adultoTotalSum'>{resultValue}</td>
      <td style={expectedCol}>{expectedValue}</td>
    </tr>);
  }
  handleAdultoStatChange(stat, index) {
    return (value) => {
      const statValues = this.state.adultoStats[stat];
      const newValues = R.update(index, value, statValues);
      this.setStateAndNotify({ adultoStats: merge(this.state.adultoStats, { [stat]: newValues }) });
    }
  }
  handleJovenStatChange(index) {
    return (value) => {
      const statValues = this.state.jovenStats;
      const newValues = R.update(index, value, statValues);
      this.setStateAndNotify({ jovenStats: newValues });
    }
  }
  handleStatChange(id) {
    return (value) => {
      this.props.onStatChange(merge(this.props.stats, { [id]: value }));
    }
  }
  renderProp(type) {
    return (prop) => {
      const cell = this.props.editable === false ?
        this.props.value[prop] :
        <NumberInput className='form-control' onChange={this.handleChange(prop)} value={this.props.value[prop]} min='0' max={[150, 59][type]}></NumberInput>
      return <td key={prop}>{cell}</td>;
    }
  }
  handleChange(field) {
    return (value) => {
      this.props.onChange(merge(this.props.value, { [field]: value, valid: true }));
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/benzinger/Form.jsx